import React, { useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { getPasskey, isFramed, passkeysSupported, mfaErr } from "../../lib/webauthn";

// Changes to MFA need a fresh confirmation (10 minutes). Holds the step-up token for the Security page.
export default function StepUpPanel({ status, stepUp, setStepUp }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const live = stepUp && stepUp.until > Date.now();
  const canPasskey = status.passkeys_active_for_this_site && passkeysSupported() && !isFramed();
  const done = (r) => setStepUp({ token: r.data.step_up_token, until: Date.now() + (r.data.expires_in - 15) * 1000 });
  const run = async (fn) => { setBusy(true); setErr(""); try { done(await fn()); setCode(""); } catch (e) { setErr(mfaErr(e)); } finally { setBusy(false); } };
  const passkey = () => run(async () => {
    const o = (await api.post("/mfa/passkeys/authenticate/options")).data;
    return api.post("/mfa/passkeys/authenticate/verify", { challenge_id: o.challenge_id, credential: await getPasskey(o.options) });
  });
  const viaCode = (e) => {
    e.preventDefault();
    const c = code.trim();
    run(() => (/^\d{6}$/.test(c) && status.totp.status === "active" ? api.post("/mfa/totp/verify", { code: c }) : api.post("/mfa/recovery/verify", { code: c })));
  };
  if (live) return <p className="text-xs text-green-800" role="status" data-testid="mfa-stepup-ok">Confirmed. You can make changes for the next few minutes.</p>;
  return (
    <div className="bg-erf-cream border border-erf-borderCream rounded p-3 space-y-2" data-testid="mfa-stepup">
      <p className="text-sm font-nav">Confirm it's you to make changes</p>
      {err && <p role="alert" className="text-xs text-red-700" data-testid="mfa-stepup-error">{err}</p>}
      <div className="flex flex-wrap gap-2 items-end">
        {canPasskey && <Button type="button" disabled={busy} onClick={passkey} className="min-h-[44px] bg-erf-dark text-white" data-testid="mfa-stepup-passkey">Use passkey</Button>}
        <form onSubmit={viaCode} className="flex gap-2 items-end">
          <label htmlFor="mfa-stepup-code" className="text-xs">Code
            <input id="mfa-stepup-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="123456 or recovery code"
              className="block min-h-[44px] rounded border border-erf-borderCream px-3 text-sm" data-testid="mfa-stepup-code" />
          </label>
          <Button type="submit" disabled={busy || code.trim().length < 6} variant="outline" className="min-h-[44px]" data-testid="mfa-stepup-submit">Confirm</Button>
        </form>
      </div>
    </div>
  );
}
